function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M112.9,76.4c0.2,1.9,0.4,3.7,0.4,5.7c0,24.5-19.9,44.4-44.4,44.4S24.5,106.5,24.5,82s19.9-44.4,44.4-44.4v-4.9 c-27.2,0-49.3,22.1-49.3,49.3c0,27.2,22.1,49.3,49.3,49.3s49.3-22.1,49.3-49.3c0-1.9-0.1-3.8-0.4-5.7H112.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M73.2,22.1v54.2l7.3-8.3h51.8V22.1H73.2z M87.2,60.6c0,0.2-0.2,0.4-0.4,0.4h-4c-0.2,0-0.4-0.2-0.4-0.4v-4.2 c0-0.2,0.2-0.4,0.4-0.4h4c0.2,0,0.4,0.2,0.4,0.4V60.6z M87.2,46.5c0,0.2-0.2,0.4-0.4,0.4h-4c-0.2,0-0.4-0.2-0.4-0.4v-4.2 c0-0.2,0.2-0.4,0.4-0.4h4c0.2,0,0.4,0.2,0.4,0.4V46.5z M87.2,32.3c0,0.2-0.2,0.4-0.4,0.4h-4c-0.2,0-0.4-0.2-0.4-0.4v-4.2 c0-0.2,0.2-0.4,0.4-0.4h4c0.2,0,0.4,0.2,0.4,0.4V32.3z M127,60.6c0,0.2-0.2,0.4-0.5,0.4h-30c-0.3,0-0.5-0.2-0.5-0.4v-4 c0-0.2,0.2-0.4,0.5-0.4h30c0.3,0,0.5,0.2,0.5,0.4V60.6z M127,46.4c0,0.2-0.2,0.4-0.5,0.4h-30c-0.3,0-0.5-0.2-0.5-0.4v-4 c0-0.2,0.2-0.4,0.5-0.4h30c0.3,0,0.5,0.2,0.5,0.4V46.4z M127,32.2c0,0.2-0.2,0.4-0.5,0.4h-30c-0.3,0-0.5-0.2-0.5-0.4v-4 c0-0.2,0.2-0.4,0.5-0.4h30c0.3,0,0.5,0.2,0.5,0.4V32.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M77.9,76.4l-9,8.1V51.2c-17.3,0-31.4,14.1-31.4,31.4S51.6,114,68.9,114s31.4-14.1,31.4-31.4 c0-2.2-0.2-4.3-0.6-6.3H77.9z"
}));

var SvgAssignableButtonsIcon = function SvgAssignableButtonsIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAssignableButtonsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assignable-buttons-icon.37c7fa3d.svg";
export { ForwardRef as ReactComponent };